export enum ForgotPasswordFieldsNames {
  Email = 'email',
}

export interface ForgotPasswordFormFields {
  [ForgotPasswordFieldsNames.Email]: string;
}
